<template>
  <div class="ehang-gantt" ref="gantt-map-box">
    <div class="time-content" ref="mian">
      <!-- 导向符号 -->
      <div class="nav-aowllbox">
        <div class="head-img-left head-img" @click.stop="moveLeft">
          <i class="icon iconfont iconicon_arrow_1-copy"></i>
        </div>
        <div class="head-img-right head-img" @click.stop="moveRight">
          <i class="icon iconfont iconicon_arrow_1-copy"></i>
        </div>
      </div>
      <div class="time-content-header" ref="header">
        <div class="time-header-box" v-if="mode === 'year'" >
          <div class="time-header--tip" v-for="(item) in yearTop" :key="getKeyDays(item) + 'top-head'" :style="{'width': yearLanWidth(item) + 'px'}">
            <span >{{getModelType(item)}}</span>
          </div>
        </div>
        <div class="time-header-box" v-else >
          <div class="time-header--tip" v-for="(item) in dayTop" :key="getKeyDays(item) + 'top-head'" :style="{'width': lanWidth(item) + 'px'}">
            <span >{{getModelType(item)}}</span>
          </div>
        </div>
        <div class="time-header-box" v-if="mode === 'year'">
          <div class="time-header--item" v-for="(item) in yearInBox" :key="getKeyDays(item) + 'year-head'" :style="{...item.axleStyle,'width': item.width + 'px'}" :class="{'todayClass': item.isToday, 'first-day': true}">
            <span>{{item.text}}</span>
          </div>
        </div>
        <div class="time-header-box" v-else>
          <div class="time-header--item" v-for="(item) in isInBox" :key="getKeyDays(item) + '-head'" :style="{...item.axleStyle,'width': dayMode[mode].width + 'px'}" :class="{'todayClass': item.isToday, 'first-day': item[dayMode[mode].is]}">
            <span>{{item[dayMode[mode].show]}}</span>
          </div>
        </div>
        <!-- hover快 -->
        <div class="hover-time" :class="{'hover-time-show': hoverTimeData.blockMove}" :style="{width: hoverTimeData.width + 'px', left: hoverTimeData.left + 'px'}"></div>
      </div>
      <div class="time-content-line" ref="content" @mousemove="mapMove($event)" @mousedown="mapDown($event)" @mouseup="mapUp($event)">
        <!-- 内容 -->
        <main class="time-content-main" :style="{width:mianWidth + 'px',height:bandelHeight +'px'}">
          <div class="time-main">
            <template v-for="(item,index) in listPull">
               <!-- 清单进度 -->
              <div v-if="item.isTaskList && item.close" class="close-box" :key="item.id + '_' + index + '_' + 'close'" :style="{left:item.left + 'px',top:item.top + 'px'}" @mouseover.stop="toggerCloseTip($event,index)">
                <div class="close-box-in" :style="{width: item.width + 'px', ...item.style}" @mouseover.stop>
                  <span style="padding-right:8px;" v-if="item.width > 49">{{item.title}}</span>
                  <span>{{item.task_list_complete_schedule}}</span>
                </div>
              </div>
              <!-- 任务进度 -->
              <div class="task-box-obj" :data-id="item.id" v-else-if="!item.isTaskList && item.start_time" :key="item.id" :style="{left:item.left + 'px',top: item.top + ((50 - item.itemStyle.heightNumber) / 2) + 'px'}">
                <!-- 左连线点 -->
                <div class="round round-left" :style="{'background-color':item.showLine  && dotData.way === 'left' ? '#2682FF' : '#6E798A'}" :class="{'round-display': item.showLine  && dotData.way === 'left', 'not-drag-left': !item.dragIcon}" v-if="item.connect" @mousedown.stop="roundDown($event,item,'left')">
                  <div class="hot-zone"></div>
                  <div class="full-screen" v-if="item.showLine && dotData.way === 'left'"  :style="{'width': dotData.width + 'px','transform':`rotate(${dotData.rota}deg)`} ">
                    <div class="line"></div>
                    <div class="jt"></div>
                  </div>
                </div>
                <div class="task-box-obj-out" :class="{'round-display': item.showLine, 'round-change': !item.dragIcon, 'round-hidden': item.task_stage === '已归档' || !item.dragIcon}" @mouseover.stop="hoverTimeOver(item)" @mouseleave="hoverTimeLeave(item)">
                  <!-- 左抓取 -->
                  <div class="iocn_resize iocn_resize_left" @mousedown.stop="checkResize($event,'left',item,index)" v-if="item.dragIcon">
                    <i class="icon iconfont iconicon_drag_task"></i>
                  </div>
                  <!-- 右抓取 -->
                  <div class="iocn_resize iocn_resize_right" @mousedown.stop="checkResize($event,'right',item,index)" v-if="item.dragIcon">
                    <i class="icon iconfont iconicon_drag_task"></i>
                  </div>
                </div>
                <div class="task-box-obj-in" @mousedown.stop="checkResize($event,'block',item,index)" @mouseover.stop="hoverTimeOver(item)" @mouseleave="hoverTimeLeave(item)">

                  <div class="task-box" :style="{width:item.width + 'px',...item.itemStyle}" @mouseover="toggerTip($event,index)">
                    <div class="task-info" v-if="item.width > 16" :style="{'line-height': item.itemStyle.height}">
                      {{item.task_name}}
                    </div>
                  </div>


                </div>
                <!-- 右连线点 -->
                <div class="round round-right" :style="{'background-color':item.showLine && dotData.way === 'right' ? '#2682FF' : '#6E798A'}" :class="{'round-display': item.showLine && dotData.way === 'right', 'not-drag-right': !item.dragIcon}" v-if="item.connect" @mousedown.stop="roundDown($event,item,'right')">
                  <div class="hot-zone"></div>
                  <div class="full-screen" v-if="item.showLine && dotData.way === 'right'"  :style="{'width': dotData.width + 'px','transform':`rotate(${dotData.rota}deg)`} ">
                    <div class="line"></div>
                    <div class="jt"></div>
                  </div>
                </div>
              </div>
            </template>


            <div class="time-line-svg">
              <div v-for="(item) in isInBox" class="time-main--item" :key="getKeyDays(item) + '-main'" :style="{...item.style,height:bandelHeight +'px', 'width': dayMode[mode].width + 'px'}">
                <div class="line-today" v-if="item.isToday"></div>
              </div>
            </div>

            <svg width="100%" :height="bandelHeight" class="time-line-connect">
              <defs>
                <marker id="markerArrow" refX="0" refY="3" markerWidth="4" markerHeight="6" orient="auto">
                  <path class="time-path-jt" d="M0,0 L0,6 L4,3 L0,0" />
                </marker>
              </defs>
              <path class="time-path" v-for="item in lines" :key="item.id" :d="item.d" stroke-width="2" fill="none" @mouseover="pathCopyHover(item)" @mouseleave="pathMouseLeave" marker-end="url(#markerArrow)"></path>
              <svg class="path-jt" @mouseover="pathMouseHover($event)" @mousemove="pathMouseMove($event)" @mouseleave="pathMouseLeave">
                <defs>
                  <marker id="arrowDefsCopy" refX="0" refY="3" markerWidth="4" markerHeight="6" orient="auto">
                    <path class="time-path-jt" d="M0,0 L0,6 L4,3 L0,0" />
                  </marker>
                </defs>
                <path class="time-path-copy" :d="pathCopy.d" stroke-width="2" fill="none" marker-end="url(#arrowDefsCopy)"></path>
              </svg>
            </svg>
          </div>
        </main>
        <!-- 提示 -->
        <div class="path-tip" :style="pathTip.style" v-if="pathTip.show" @mousemove="pathTipShow" @mouseover="pathTipShow" @mouseleave="pathMouseLeave">
          <p @click="onlyShow">
            <el-tooltip class="item" effect="dark" content="仅显示关联线" placement="top">
              <i class="icon iconfont iconicon_show_connection"></i>
            </el-tooltip>
          </p>
          <p @click="delConnect">
            <el-tooltip class="item" effect="dark" content="删除关联" placement="top">
              <i class="icon iconfont iconicon_delete"></i>
            </el-tooltip>
          </p>
        </div>
        <!-- 删除提示 -->
        <div class="del-tip" :style="delTip">
          <el-popover :visible-arrow="true" popper-class="del-tip-popover" placement="top" width="256" trigger="manual" v-model="visible" :transition="null" :append-to-body="false">
            <div class="del-tip-content">
              <img src="image/icon/alert.png" alt="">
              <span>确定解除任务关联吗</span>
            </div>
            <div class="btns">
              <span class="cancel text-btn-active" style="margin-right:24px;" @click="cancelDelLine">取消</span>
              <wf-button type="danger" @click="reayDelLine">确定</wf-button>
            </div>
            <div slot="reference" @click="visible = !visible"></div>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="tool-week">
      <span class="tool-week-day" v-if="showAllLines" @click="setLinesArr">显示全部连线</span>
      <span class="tool-week-day" @click="today">今天</span>
      <el-dropdown @command="handleCommand"  trigger="click" @visible-change="showTimeEvent">
        <span class="el-dropdown-link tool-week-select">
          {{dayMode[mode].txt}}<i class="arrow-down icon iconfont iconicon_drop_down_arrow" :class="{'rotaEle': timeShow}"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="week">周</el-dropdown-item>
          <el-dropdown-item command="month">月</el-dropdown-item>
          <el-dropdown-item command="year">年</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import elementResizeDetectorMaker from 'element-resize-detector'
import bus from '@/bus'
import { taskLevelMap } from "@/utils/const.js"
import tippy, { inlinePositioning, followCursor } from 'tippy.js';
import dayjs from "dayjs";
import { mapActions, mapMutations, mapState } from 'vuex'
import api from '@/services/api/connect/connect'
import { dateReminder } from '@/utils'
import VueSticky  from 'vue-sticky';
export default {
  props: {
    dataset: {
      type: Object,
      default: {
        unArchClose: false,
        archClose: false,
        unArch:[],
        arch: []
      }
    },
    normal: {
      type: Boolean,
      default: false
    },
    tooltipContent: {
      type: Function,
      default: (item, idx, _this) => {
        return `
          <div class="gantt-tip">
            <div class="gantt-tip-name">${item.task_name}</div>
            <div class="gannt-tip-item">
              <i class="icon iconfont iconicon_executor"></i>
              <p>${item.executor_user ? item.executor_user.realname : ''}</p>
            </div>
            <div class="gannt-tip-item">
              <i class="icon iconfont iconicon_time1"></i>
              <p >${_this.resetTime(item.start_time)} - ${_this.resetTime(item.end_time)}</p>
            </div>
          ${_this.getPost_tasks_id(item).length > 0 || _this.getPre_tasks_id(item).length > 0 ? `<div class="tip-btn" onclick="showLineTask(${idx})" data-idx="${idx}">查看关联任务线</div>` : ''}
          </div>`
      }
    },
    itemCheck: {
      type: Function,
      default: (item, _this) => {
        _this.opendTaskDetail(item)
      }
    },
  },
  components: {
  },
  data() {
    return {
      overTime: [new Date(new Date().getFullYear() - 10, new Date().getMonth(), 1).getTime(), new Date(new Date().setFullYear(new Date().getFullYear() + 10)).getTime()],
      taskLevel: taskLevelMap || [],
      originData: [],
      dateList: [], // 天数展开数据
      days: [], // 层级数据
      mode: 'week',
      nowDayTip: '',
      saveIndex: '',
      isCanMove: false,
      isCanTrMove: false,
      move_x: 0,
      move_y: 0,
      rendBack: ['#fff', 'rgba(32, 32, 32, 0.04)'],
      listPull: [], // 传入的数据平铺处理
      bandelHeight: 50, // 容器实际高度
      contentScorllLeft: 0, // 当前左侧滚动距离
      inContainerWidth: 0, // 容器可视宽度
      inContainerHeight: 0, // 容器可视高度
      hoverTaskId: '', // 高亮id
      isTimeChange: false,
      clickTime: 0, // 点击时间长短,判断是点击还是移动
      timer: null,
      visible: false,
      lines: [], // 每个线的坐标
      linesCopy: [], // 存储坐标
      showAllLines: false,
      pathCopy: {},
      pathTimeOut: null,
      dragTime: false,
      delTip: {
      },
      bk: {
        1: {
          complete: {
            background: '#E4E4E4',
            color: 'rgba(32, 32, 40, 0.4)',
            borderRadius: '2px',
            height: '28px',
            heightNumber: 28
          },
          expired: {
            background: '#FFD1D1',
            color: '#F23A3A',
            borderRadius: '2px',
            height: '28px',
            heightNumber: 28
          },
          remind: {
            background: '#FFE7C2',
            color: '#ED6B06',
            borderRadius: '2px',
            height: '28px',
            heightNumber: 28
          },
          normal: {
            background: '#CBE1FF',
            color: '#0463D6',
            borderRadius: '2px',
            height: '28px',
            heightNumber: 28
          },
          arch: {
            background: '#E4E4E4',
            color: 'rgba(32, 32, 40, 0.4)',
            borderRadius: '2px',
            height: '28px',
            textDecoration: 'line-through',
            heightNumber: 28
          }
        },
        2: {
          complete: {
            background: '#E4E4E4',
            color: 'rgba(32, 32, 40, 0.4)',
            borderRadius: '12px',
            height: '20px',
            heightNumber: 20
          },
          expired: {
            background: '#FFD1D1',
            color: '#F23A3A',
            borderRadius: '12px',
            height: '20px',
            heightNumber: 20
          },
          remind: {
            background: '#FFE7C2',
            color: '#ED6B06',
            borderRadius: '12px',
            height: '20px',
            heightNumber: 20
          },
          normal: {
            background: '#CBE1FF',
            color: '#0463D6',
            borderRadius: '12px',
            height: '20px',
            heightNumber: 20
          },
          arch: {
            background: '#E4E4E4',
            color: 'rgba(32, 32, 40, 0.4)',
            borderRadius: '12px',
            height: '20px',
            textDecoration: 'line-through',
            heightNumber: 20
          }
        },
        3: {
          complete: {
            background: '#E4E4E4',
            color: 'rgba(32, 32, 40, 0.4)',
            borderRadius: '12px',
            border: '1px solid rgba(32,32,32,0.16)',
            height: '20px',
            heightNumber: 20
          },
          expired: {
            background: '#FFEEEF',
            color: '#F01515',
            borderRadius: '12px',
            height: '20px',
            border: '1px solid #FFA5A9',
            heightNumber: 20
          },
          remind: {
            background: '#FFF7E0',
            color: '#ED6B06',
            borderRadius: '12px',
            height: '20px',
            border: '1px solid #FFC190',
            heightNumber: 20
          },
          normal: {
            background: '#EBF4FF',
            color: '#0463D6',
            borderRadius: '12px',
            height: '20px',
            border: '1px solid #A7CDFF',
            heightNumber: 20
          },
          arch: {
            background: '#E4E4E4',
            color: 'rgba(32, 32, 40, 0.4)',
            borderRadius: '12px',
            border: '1px solid rgba(32,32,32,0.16)',
            height: '20px',
            textDecoration: 'line-through',
            heightNumber: 20
          }
        }
      },
      listBk: [{
        background: 'linear-gradient(270deg, #6b97cf 0%, #456fb3 100%)',
        color: '#fff'
      },{
        background: '#E4E4E4',
        color: 'rgba(32, 32, 32, 0.4)'
      }],
      pathTip: {
        style: {
          left: 0,
          top: 0
        },
        show: false
      },
      dayMode: {
        'week': {
          width: 49,
          txt: '周',
          is: 'isMouStart',
          show: 'day',
          key: 'day'
        },
        'month': {
          width: 26,
          txt: '月',
          is: 'isMouStart',
          show: 'day',
          key: 'month'
        },
        'year': {
          width: 4,
          txt: '年',
          is: 'isYearStart',
          show: '',
          key: 'year'
        }
      },
      hoverTimeData: {
        blockMove: false,
        width: 0,
        left: 0
      },
      dotData: {
        width: 0,
        rota: 0,
        way: ''
      },
      timeShow: false
    }
  },
  directives:{
    'sticky': VueSticky,
  },
  computed: {
    mianWidth() {
      return this.dateList.length * this.dayMode[this.mode].width
    },
    yearInBox() {
      let arr = []
      for(let key in this.days) {
        for(let m in this.days[key]) {
          arr.push({
            year: key,
            month: m,
            text: `${key}年${m}月`,
            isYearStart: m == 1,
            tipShow: true,
            width: this.days[key][m].length * this.dayMode[this.mode].width
          })
        }
      }
      return arr
    },
    yearTop() {
      console.log(this.yearInBox, this.dayMode[this.mode].is)
      return this.yearInBox.filter(res => {
        return res[this.dayMode[this.mode].is]
      })
    },
    isInBox() {
      return this.dateList
      // return this.dateList.filter(res => {
      //   let po = this.dayMode[this.mode].width * 4
      //   return res.left < this.contentScorllLeft + this.$refs.content.offsetWidth + po && res.left > this.contentScorllLeft - po
      // })
    },
    dayTop() {
      return this.dateList.filter(res => {
        return res[this.dayMode[this.mode].is]
      })
    },
    ...mapState('task/task', {
      isDisabledProject: state => state.isDisabledProject
    })
  },
  watch: {
    dataset: {
      handler() {
        this.ready()
      },
      deep: true
    },
    contentScorllLeft(val) {
      this.$refs.header ? this.$refs.header.scrollLeft = val : ''
      this.$refs.content ? this.$refs.content.scrollLeft = val : ''
    },
    // hoverTaskId(val) {
    //   for (let i = 0; i < this.$refs.tr.length; i++) {
    //     if (this.$refs.tr[i].dataset.id == val) {
    //       this.$refs.tr[i].style.background = 'rgba(166, 166, 182, 0.16)'
    //     } else {
    //       this.$refs.tr[i].style.background = 'initial'
    //     }
    //   }
    // }
  },
  beforeDestroy() {
    this.erd.removeAllListeners(this.$refs['mian'])
    window.removeEventListener('mouseup', this.windMouseUp)
  },
  mounted() {
    window.showLineTask = (idx) => {
      this.showLineTask(idx)
    }
    this.init()
    this.setBus()
  },
  beforeDestroy() {
    bus.$off('clearCloseTask')
  },
  methods: {
    ...mapActions('task/task', ['editTask', 'updateFormKey']),
    ...mapMutations('task/task',['CHANGE_TASK']),
    lanWidth(item) {
      let { year ,month, day } = item
      return (this.days[year][month]).length * this.dayMode[this.mode].width
    },
    yearLanWidth(item) {
      let { year ,month, day } = item
      let width = 0
      for(let key in this.days[year]) {
        width += (this.days[year][key]).length * this.dayMode[this.mode].width
      }
      return width
    },
    setBus() {
      bus.$on('ganttMapScrollChange',this.scorllTopChange)
    },
    scorllTopChange(n){
      if(this.$refs.content) {
        this.$refs.content.scrollTop =  n
      }
    },
    addSuccess(id, task_id) {
      this.$refs.table.addSuccess(id, task_id)
    },
    init() {
      this.createTimeData()
      this.filterList()
      this.addEventListenerBase()
      this.today()
    },
    ready() {
      this.filterList()
    },
    getYearMonthDay(str) {
      let ds = new Date(str)
      let month = ds.getMonth() + 1
      let year = ds.getFullYear()
      let day = ds.getDate()
      let week = ds.getDay()
      return {
        year,
        month,
        day,
        week
      }
    },
    filterList() {
      this.pathCopy = {}
      this.listPull = []
      this.bandelHeight = 50
      this.listPull.push({
        style: {
          height: '50px',
          width: this.mianWidth + 'px'
        },
        start_time: '',
        end_time: '',
        id: 'unArch',
        top: this.bandelHeight,
      })
      if(!this.dataset.unArchClose) {
        this.dataCompete(this.dataset.unArch)
      }
      this.bandelHeight = this.bandelHeight + 50
      this.listPull.push({
        style: {
          height: '50px',
          width: this.mianWidth + 'px'
        },
        start_time: '',
        end_time: '',
        id: 'arch',
        top: this.bandelHeight,
      })
      if(!this.dataset.archClose) {
        this.dataCompete(this.dataset.arch)
      }
      this.bandelHeight = this.bandelHeight + 42 < this.inContainerHeight ? this.inContainerHeight : this.bandelHeight + 42
      this.setLinesArr()
    },
    dataCompete(dataset) {
      let rest = (data) => {
        let arr = []
        if (data.close) {
          return
        }
        if (Array.isArray(data)) {
          arr = JSON.parse(JSON.stringify(data))
        } else {
          for (let key in data) {
            if (typeof (data[key]) === 'object' && data[key] && data[key].length > 0) {
              let p = JSON.parse(JSON.stringify(data[key]))
              arr.push(...p)
            } else if(data[key] && data[key].length === 0) { // 空level最小高度为1
              this.bandelHeight = this.bandelHeight + 1
            }
          }
        }
        arr.forEach((temp, index) => {
          if (!temp.start_time) {
            temp.start_time = ''
            temp.end_time = ''
          } else {
            let start = this.getYearMonthDay(temp.start_time)
            let end = this.getYearMonthDay(temp.end_time)
            temp.width = this.days[end.year][end.month][end.day - 1].left - this.days[start.year][start.month][start.day - 1].left + this.dayMode[this.mode].width
            temp.top = this.bandelHeight
            temp.left = this.days[start.year][start.month][start.day - 1].left
            temp.dragleft = {
              left: -3,
              top: -3,
              show: false,
              svg: {
                width: 16,
                height: 16,
              },
              transform: `rotateX(0) rotateY(0)`
            }
            temp.dragright = {
              left: -3,
              top: -3,
              show: false,
              svg: {
                width: 16,
                height: 16,
              },
              transform: `rotateX(0) rotateY(0)`
            }
            let style = {}
            style = { ...this.getMaiLine(temp) }
            temp.dragIcon = !(temp.task_stage === '已完成' || temp.task_stage === '已归档' || !temp.edit_permission || this.isDisabledProject)
            temp.connect = !(temp.task_stage === '已归档' || !temp.edit_permission || !temp.association_permission || this.isDisabledProject)
            // temp.iconColor = taskLevel.icon
            temp.itemStyle = style
          }
          this.listPull.push(temp)
          this.bandelHeight = this.bandelHeight + 50
          if (temp.tasks && temp.open) {
            rest(temp.tasks)
          }
        })
      }
      if(dataset && dataset[0] && dataset[0].task_name) {
        rest(dataset)
        return
      }
      dataset.forEach(res => {
        if(!res.close || (res?.closeData?.task_list_start_time && res?.closeData?.task_list_end_time)) {
          let originData = {
            start_time: '',
            end_time: '',
            id: res.task_list_id,
            top: this.bandelHeight,
            close: res.close,
            isTaskList: true
          }
          let objData = {}
          if(res.closeData && res.closeData.task_list_start_time && res.closeData.task_list_end_time) {
            let start = this.getYearMonthDay(res.closeData.task_list_start_time)
            let end = this.getYearMonthDay(res.closeData.task_list_end_time)
            objData = {
              start_time: res.closeData.task_list_start_time,
              end_time: res.closeData.task_list_end_time,
              width: this.days[end.year][end.month][end.day - 1].left - this.days[start.year][start.month][start.day - 1].left + this.dayMode[this.mode].width,
              left: this.days[start.year][start.month][start.day - 1].left,
              task_list_complete_schedule: res.closeData.task_list_complete_schedule,
              title: res.title,
              style: this.getArchMaiLine(res.isArch)
            }
          }
          let obj = {
            itemStyle: {
              height: '50px',
              width: this.mianWidth + 'px',
              heightNumber: 28
            },
            ...originData,
            ...objData
          }
          this.listPull.push(obj)
        }
        this.bandelHeight = this.bandelHeight + 50
        if(!res.close) {
          rest(res.tasks)
        }
      })
    },
    getPost_tasks_id(res) { // 获取后置的任务ID，判断是否从详情里面取出，详情和列表获取的后置节点字段不同
      if (res?.association_dependency?.post_tasks?.tasks.length > 0) {
        return res.association_dependency.post_tasks.tasks.map(res => res.associated_task.id) || []
      } else if (res?.task_association_dependency?.post_tasks_id.length > 0) {
        return res.task_association_dependency.post_tasks_id || []
      } else {
        return []
      }
    },
    getPre_tasks_id(res) {
      if (res?.association_dependency?.pre_tasks?.tasks.length > 0) {
        return res.association_dependency.pre_tasks.tasks.map(res => res.associated_task.id) || []
      } else if (res?.task_association_dependency?.pre_tasks_id.length > 0) {
        return res.task_association_dependency.pre_tasks_id || []
      } else {
        return []
      }
    },
    setLinesArr() {
      this.showAllLines = false
      this.lines = []
      this.listPull.forEach(res => {
        let connectList = this.getPost_tasks_id(res)
        if (connectList.length > 0) {
          connectList.forEach(id => {
            let posId = this.listPull.find(i => i.id === id)
            if (posId && posId.start_time && res.start_time) { // 未加载的、没有设置开始时间不连线
              let xy = {
                id: res.id + '-' + posId.id,
                permission: res.association_permission,
                start: {
                  x: res.left + res.width,
                  y: res.top + 25
                },
                end: {
                  x: posId.left - 10,
                  y: posId.top + 25
                }
              }
              let dotDown = xy.start.y - (xy.start.y - xy.end.y) / 2
              xy.d = `
              M ${xy.start.x} ${xy.start.y}
              L ${xy.start.x + 8} ${xy.start.y}
              L ${xy.start.x + 8} ${dotDown}
              L ${xy.end.x - 8} ${dotDown}
              L ${xy.end.x - 8} ${xy.end.y}
              L ${xy.end.x} ${xy.end.y}
              `
              this.lines.push(xy)
            }
          })
        }
      })
      this.linesCopy = JSON.parse(JSON.stringify(this.lines))
    },
    createTimeData() {
      var start_time = this.overTime[0]
      var end_time = this.overTime[1]
      var bd = new Date(start_time), be = new Date(end_time)
      var bd_time = bd.getTime(), be_time = be.getTime(), time_diff = be_time - bd_time
      var d_arr = {}
      let dateList = []
      for (var i = 0, j = 0; i <= time_diff; i += 86400000) {
        var ds = new Date(bd_time + i)
        let mou = ds.getMonth() + 1
        let year = ds.getFullYear()
        let day = ds.getDate()
        let week = ds.getDay()
        let isYearStart = mou === 1 && day === 1
        let isMouStart = day === 1
        if (d_arr[year] && d_arr[year][mou]) {
          d_arr[year][mou].push({
            val: day,
            left: this.dayMode[this.mode].width * j,
            week: week,
            today: false,
            isYearStart,
            isMouStart
          })
        } else {
          if (d_arr[year]) {
            d_arr[year][mou] = [{
              val: day,
              left: this.dayMode[this.mode].width * j,
              week: week,
              today: false,
              isYearStart,
              isMouStart
            }]
          } else {
            d_arr[year] = {}
            d_arr[year][mou] = [{
              val: day,
              left: this.dayMode[this.mode].width * j,
              week: week,
              today: false,
              isYearStart,
              isMouStart
            }]
          }
        }
        let dateObj = {
          year: year,
          month: mou,
          left: this.dayMode[this.mode].width * j,
          day: day,
          week: week,
          isYearStart,
          isMouStart,
          tipShow: true,
          width: this.dayMode[this.mode].width
        }
        dateObj.isToday = this.getToDayLine(dateObj)
        dateObj.style = this.getItemStyle(dateObj)
        dateList.push(dateObj)
        j++
      }
      this.dateList = JSON.parse(JSON.stringify(dateList))
      this.days = JSON.parse(JSON.stringify(d_arr))
    },
    getKeyDays(item) {
      return `${item.year}-${item.month}-${item.day}`
    },
    getModelType(item) {
      let str = ''
      switch (this.mode) {
        case 'week':
          str = `${item.year}年${item.month}月`
          break
        case 'month':
          str = `${item.year}年${item.month}月`
          break
        case 'year':
          str = `${item.year}年`
          break
        default:
          str = ''
      }
      return str
    },
    today() {
      let day = new Date().getDate()
      let month = new Date().getMonth() + 1
      let year = new Date().getFullYear()
      this.$nextTick(() => {
        let width = this.$refs['content'].offsetWidth
        let val = this.days[year][month][day - 1].left - width / 2
        setTimeout(() => {
          this.contentScorllLeft = val
        }, 1000)
      })
    },
    getToDayLine(item) {
      let day = new Date().getDate()
      let month = new Date().getMonth() + 1
      let year = new Date().getFullYear()
      return item.year === year && item.day === day && item.month === month
    },
    handleCommand(e) {
      this.mode = e
      this.init()
      this.ready()
    },
    getItemStyle(item) {
      // let key = this.dayMode[this.mode].key
      return {
        width: this.dayMode[this.mode].width + 'px',
        // background: item.week === 0 || item.week === 6 ? '#F1F2F4' : this.rendBack[item[key] % 2]
        background: item.week === 0 || item.week === 6 ? '#F7F7F7' : this.rendBack[0]
      }
    },
    mapMove(e) {
      if (!this.isCanMove) { return }
      let x = 0
      let y = 0
      x = e.clientX - this.move_x
      y = e.clientY - this.move_y
      this.move_x = e.clientX
      this.move_y = e.clientY
      let val = this.$refs['content'].scrollLeft - x
      this.contentScorllLeft = val
      bus.$emit('changeTableScroll', -y)
    },
    mapDown(e) {
      // this.$refs['content'].style.cursor = 'grabbing'
      this.move_x = e.clientX
      this.move_y = e.clientY
      this.isCanMove = true
    },
    mapUp(e) {
      this.move_x = 0
      // this.$refs['content'].style.cursor = 'grab'
      this.isCanMove = false
    },
    addEventListenerBase() {
      window.addEventListener('mouseup', this.windMouseUp)
      this.$nextTick(() => {
        this.erd = elementResizeDetectorMaker();
        this.erd.listenTo(this.$refs['mian'], async (ele) => {
          this.inContainerWidth = ele.offsetWidth
          this.inContainerHeight = ele.offsetHeight
        })
      })
    },
    windMouseUp(e) {
      e.preventDefault()
      if (!this.$refs['content']) return
      this.isCanMove = false
      this.isCanTrMove = false
      this.move_x = 0
      // this.$refs['content'].style.cursor = 'grab'
    },
    mouseoverTr(id, e) {
      this.hoverTaskId = id
    },
    toggerTip(e, idx) {
      if (this.isCanMove) { return }
      if (this.listPull[idx].tippyInstance) {
        this.listPull[idx].tippyInstance.unmount()
        this.listPull[idx].tippyInstance.destroy()
        this.listPull[idx].tippyInstance = ''
      }
      let item = this.listPull[idx]
      let tippyInstance = tippy(e.currentTarget, {
        followCursor: 'horizontal',
        arrow: false,
        placement: 'bottom',
        theme: 'tomato',
        allowHTML: true,
        maxWidth: 350,
        interactiveBorder: 15,
        interactive: true,
        appendTo: () => this.$refs['gantt-map-box'],
        getReferenceClientRect: () => ({
          left: 0,
          top: 100,
        }),
        plugins: [followCursor]
      });
      let tooltipContent = this.tooltipContent(item, idx, this)
      tippyInstance.setContent(tooltipContent)
      this.listPull[idx].tippyInstance = tippyInstance
    },
    showLineTask(idx) {
      let item = this.listPull[idx]
      let postArr = this.getPost_tasks_id(item) // 当前点击线后置任务的后置任务ID
      let preArr = this.getPre_tasks_id(item)// 当前点击线前置任务的后置任务ID
      let arr = [...postArr.map(id => `${item.id}-${id}`), ...preArr.map(id => `${id}-${item.id}`)]
      let line = this.linesCopy.filter(res => arr.indexOf(res.id) > -1)
      this.lines = []
      this.lines = JSON.parse(JSON.stringify(line))
      this.showAllLines = true
    },
    toggerCloseTip(e, idx) {
      if (this.isCanMove) { return }
      if (this.listPull[idx].tippyInstance) {
        this.listPull[idx].tippyInstance.unmount()
        this.listPull[idx].tippyInstance.destroy()
        this.listPull[idx].tippyInstance = ''
      }
      let tippyInstance = tippy(e.target, {
        followCursor: true,
        arrow: false,
        placement: 'right-start',
        theme: 'tomato',
        allowHTML: true,
        maxWidth: 350,
        getReferenceClientRect: () => ({
          left: 16,
          top: 16,
        }),
        plugins: [followCursor]
      });
      let tooltipContent = `<div style="font-weight: bold;margin:-10px;">${this.listPull[idx].title} ${this.listPull[idx].task_list_complete_schedule}</div>`
      tippyInstance.setContent(tooltipContent)
      this.listPull[idx].tippyInstance = tippyInstance
    },
    getMaiLine(item) { // 获取进度颜色
      if(this.normal) {
        return this.bk[1].normal
      }
      let result = item.task_stage === '已归档' ? 'arch' : dateReminder(item) || 'normal'
      let level = item.task_level
      return this.bk[level][result]
    },
    getArchMaiLine(isArch) {
      let index = Number(isArch) || 0
      return this.listBk[index]
    },
    checkResize(e, way, item, index) {
      this.hoverTimeData.blockMove = true
      let x = e.clientX
      let isChange = false
      this.timer = setInterval(() => {
        this.clickTime = this.clickTime + 100
      }, 10)
      document.onmousemove = (e) => {
        e.stopPropagation()
        if (!item.edit_permission || item.task_stage === '已完成' || item.task_stage === '已归档') return
        // this.$refs.content.style.cursor = 'w-resize'
        let moveX = e.clientX
        let move = x - moveX
        let i = move > 0 ? 1 : -1
        let width = this.dayMode[this.mode].width
        if (Math.abs(move) / width > 1) {
          if (way === 'left') {
            if((this.listPull[index].width + width * i) <= 0) return
            this.listPull[index].left = this.listPull[index].left - width * i
            this.listPull[index].start_time = dayjs(new Date(new Date(this.listPull[index].start_time).setDate(new Date(this.listPull[index].start_time).getDate() - 1 * i))).format("YYYY-MM-DD")
            this.listPull[index].width = this.listPull[index].width + width * i
          } else if (way === 'right') {
            if((this.listPull[index].width - width * i) <= 0) return
            this.listPull[index].end_time = dayjs(new Date(new Date(this.listPull[index].end_time).setDate(new Date(this.listPull[index].end_time).getDate() - 1 * i))).format("YYYY-MM-DD")
            this.listPull[index].width = this.listPull[index].width - width * i
          } else {
            this.listPull[index].left = this.listPull[index].left - width * i
            this.listPull[index].start_time = dayjs(new Date(new Date(this.listPull[index].start_time).setDate(new Date(this.listPull[index].start_time).getDate() - 1 * i))).format("YYYY-MM-DD")
            this.listPull[index].end_time = dayjs(new Date(new Date(this.listPull[index].end_time).setDate(new Date(this.listPull[index].end_time).getDate() - 1 * i))).format("YYYY-MM-DD")
          }
          x = x + width * (-i)
          isChange = true
          this.setLinesArr()
          this.hoverTimeOver(item)
        }
      }
      document.onmouseup = () => {
        this.hoverTimeData.blockMove = false
        this.hoverTimeData.width = 0
        clearInterval(this.timer)
        document.onmousemove = null;
        document.onmouseup = null;
        if (isChange) {
          this.changeTime(this.listPull[index])
          isChange = false
        } else {
          if (this.clickTime >= 0 && this.clickTime < 3000) {
            this.itemCheck(this.listPull[index], this)
          }
        }
        this.clickTime = 0
      }
    },
    async changeTime(data) {
      await this.updateFormKey({
        task_id: data.id,
        data: {
          start_time: data.start_time,
          end_time: data.end_time
        }
      })
      this.$message({
        message: '完成时间修改成功',
        type: 'success'
      });
      bus.$emit('updateTask', { task_id: data.id, task_list_id: data.task_list_id })
    },
    opendTaskDetail(data) {
      let { task_list_id,  id } = data
      this.CHANGE_TASK({ visible: true, task_id: id, task_group_id: task_list_id})

    },
    roundDown(ep, item, way) {
      let connectDom = ''
      document.onmousemove = (ec) => {
        ec.stopPropagation()
        connectDom.style['z-index'] = 2
        this.$refs['content'].style.cursor = 'none'
        this.dotData.width = this.calculateDistance(ep.x, ep.y, ec.x, ec.y)
        this.dotData.rota = this.calculateRotationAngle(ep.x, ep.y, ec.x, ec.y)
        this.dotData.way = way
        this.$set(item, 'showLine', true)
      }
      document.onmouseup = (e) => {
        let nextDom = this.findDomlist(e.target)
        connectDom.style['z-index'] = 3
        this.$refs['content'].style.cursor = ''
        this.$set(item, 'showLine', false)
        this.dotData = {
          width: 0,
          rota: 0,
          way: ''
        }
        if (nextDom && item.id != nextDom.dataset.id) { // 防止链接到自己和清单
          let type = way === 'left' ? 1 : 2
          let params = {
            task_id: item.id,
            associated_type: type,
            associated_task_id: nextDom.dataset.id
          }
          api.connectGantt(params).then(res => {
            let nextPos = this.listPull.find(res => res.id == nextDom.dataset.id)
            bus.$emit('updateTask', { task_id: item.id, task_list_id: item.task_list_id })
            bus.$emit('updateTask', { task_id: nextPos.id, task_list_id: nextPos.task_list_id })
          }).catch(err => {
            console.log(err)
          })
        }
        document.onmousemove = null;
        document.onmouseup = null;
      }
      connectDom = this.findDomlist(ep.target)
    },
    calculateDistance(x1, y1, x2, y2) {
      const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2))
      return distance
    },
    calculateRotationAngle(x1,y1, x2, y2){
      const deltaX = x2 - x1
      const deltaY = y2 - y1
      const angleInRadians = Math.atan2(deltaY, deltaX)
      const angleInDegrees = angleInRadians * (180 / Math.PI)
      return angleInDegrees
    },
    findDomlist(target) {
      let dd = target.parentNode
      while (dd && dd.className !== 'task-box-obj') {
        dd = dd.parentNode
      }
      return dd
    },
    connectToNext(id, type) {

    },
    rotateMath(left, top) {
      if (left < 0 && top < 0) {
        return `rotateX(-180deg) rotateY(-180deg)`
      } else if (left < 0 && top > 0) {
        return `rotateX(0) rotateY(-180deg)`
      } else if (left > 0 && top < 0) {
        return `rotateX(-180deg) rotateY(0)`
      } else if (left < 0) {
        return `rotateX(-180deg) rotateY(0)`
      } else if (top < 0) {
        return `rotateX(0) rotateY(-180deg)`
      }
    },
    nothing() {

    },
    addTask(id) {
      this.$emit('addTask', id)
    },
    pathCopyHover(item) { // 当前hover的线
      this.visible = false
      clearTimeout(this.pathTimeOut)
      this.pathCopy = JSON.parse(JSON.stringify(item))
    },
    pathMouseHover(e) { // copy
      clearTimeout(this.pathTimeOut)
      this.pathTip.style.left = e.offsetX + 5 + 'px'
      this.pathTip.style.top = e.offsetY - 10 + 'px'
      this.pathTip.show = this.pathCopy.permission
    },
    pathMouseMove(e) { // copy
      clearTimeout(this.pathTimeOut)
      this.pathTip.style.left = e.offsetX + 5 + 'px'
      this.pathTip.style.top = e.offsetY - 10 + 'px'
    },
    pathTipShow() { // tip,hover and move
      clearTimeout(this.pathTimeOut)
      this.pathTip.show = this.pathCopy.permission
    },
    pathMouseLeave(e) { // copy
      this.pathTimeOut = setTimeout(() => {
        this.pathCopy.d = ''
        this.pathTip.show = false
      }, 300)
    },
    delConnect() {
      this.delTip = JSON.parse(JSON.stringify(this.pathTip.style))
      this.visible = true
      this.pathTip.show = false
    },
    onlyShow() {
      this.showAllLines = true
      let arr = this.pathCopy.id.split('-') // 当前点击线的ID
      let postArr = this.getPost_tasks_id(this.listPull.find(res => res.id == arr[1])) // 当前点击线后置任务的后置任务ID
      let preArr = this.getPre_tasks_id(this.listPull.find(res => res.id == arr[0]))// 当前点击线前置任务的后置任务ID
      let linePos = postArr.map(id => {  // 后置任务ID
        return `${arr[1]}-${id}`
      }) || []
      let linePre = preArr.map(id => {  // 前置任务ID
        return `${id}-${arr[0]}`
      }) || []
      this.lines = this.lines.filter(res => {
        return [...linePos, ...linePre, this.pathCopy.id].includes(res.id)
      })
    },
    cancelDelLine() {
      this.visible = false
      this.pathMouseLeave()
    },
    async reayDelLine() {
      this.visible = false
      let arr = this.pathCopy.id.split('-')
      let nextPos = this.listPull.find(res => res.id == arr[0])
      await api.cancelConnect({ task_id: arr[0], associated_task_id: arr[1] })
      bus.$emit('updateTask', { task_id: nextPos.id, task_list_id: nextPos.task_list_id })
    },
    angle(start, end) {
      var diff_x = end.x - start.x,
        diff_y = end.y - start.y;
      //返回角度,不是弧度
      return 360 * Math.atan(diff_y / diff_x) / (2 * Math.PI);
    },
    restData() {
      this.$refs.table.restData()
    },
    moveLeft() {
      this.contentScorllLeft = this.contentScorllLeft - 600
    },
    moveRight() {
      this.contentScorllLeft = this.contentScorllLeft + 600
    },
    topTimeline(item) {
      let {start_time, end_time} = item
      let itemWidth = this.dayMode[this.mode].width
      let timeDiff = Math.abs(new Date(end_time) - new Date(start_time))
      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1
      return diffDays * itemWidth
    },
    hoverTimeOver(item) {
      this.hoverTimeData.width = this.topTimeline(item)
      this.hoverTimeData.left = item.left
    },
    hoverTimeLeave(item) {
      if(this.hoverTimeData.blockMove) return
      this.hoverTimeData.width = 0
    },
    showTimeEvent(val) {
      console.log('--------asd-------', val)
      this.timeShow = val
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.ehang-gantt {
  width: 100%;
  height: 100%;
  display: flex;
  user-select: none;
  overflow: hidden;
  transform: translateZ(0);
  .del-tip {
    position: absolute;
    margin-top: 10px;
  }
  .path-tip {
    position: absolute;
    z-index: 999;
    display: flex;
    border-radius: 2px;
    background-color: #fff;
    cursor: auto;
    box-shadow: 0px 2px 8px 0px rgba(13, 31, 60, 0.16);
    p {
      cursor: pointer;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      &:hover {
        color: $color-active;
      }
    }
  }
  .time-content-header {
    width: 100%;
    overflow: hidden;
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    .time-header-box {
      display: flex;
      box-sizing: border-box;
    }
    .time-header--tip{
      height: 25px;
      background-color: #fff;
      font-size: 14px;
      color:rgba(32, 32, 32, 0.8);
      font-weight: 500;
      border-left:1px solid rgba(32, 32, 32, 0.08);
      flex-shrink: 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      span{
        margin-left: 16px;
        position: sticky;
        left: 16px;
        z-index: 991;
        padding-right: 16px;
      }
    }
    .time-header--item {
      flex-shrink: 0;
      height: 24px;
      text-align: center;
      line-height: 24px;
      color: #73728d;
      font-size: 12px;
      font-weight: 400;
      box-sizing: border-box;
      border-top: 1px solid rgba(32, 32, 32, 0.08);
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      background-color: #fff;
      span {
        position: relative;
        z-index: 993;
      }
    }
    .todayClass {
      background: rgba(38, 130, 255, 1) !important;
      color: #fff;
      border-radius: 2px;
      position: relative;
      z-index: 993;
    }
    .first-day{
      border-left: 1px solid rgba(32, 32, 32, 0.08);
    }
  }
  .hover-time {
    height: 24px;
    background-color: rgba(228, 228, 228,1);
    border-radius: 2px;
    position: absolute;
    top: 25px;
    z-index: 992;
  }
  .time-content {
    height: 100%;
    position: relative;
    width: 0;
    flex: 1;
    &:hover {
      .nav-aowllbox {
        visibility: visible;
      }
    }
    .nav-aowllbox {
      visibility: hidden;
    }
    .head-img {
      user-select: none;
      position: absolute;
      top: 50%;
      width: 54px;
      height: 54px;
      transform: translate(0, -50%);
      box-shadow: 0px 4px 8px 0px rgba(32,32,32,0.16);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 11 !important;
      background-color: #fff;
      &:hover {
        background-color: #fff;
      }
      &:active {
        background-color: #eeeef1;
      }
      i {
        color: rgba(32, 32, 32, 0.6);
      }
      z-index: 2;
    }
    .head-img-left {
      left: 17px;
      i {
        transform: rotate(180deg);
      }
    }
    .head-img-right {
      right: 17px;
    }
    .now-day-tip {
      position: absolute;
      top: 26px;
      left: 10px;
      width: 100px;
      text-align: center;
      z-index: 1;
      color: #0d1f3c;
      font-size: 16px;
      font-weight: bold;
      height: 47px;
      line-height: 47px;
    }
  }
  .line-today {
    width: 1px;
    height: 100%;
    background-color: #509aff;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
    z-index: 2;
    &::after {
      content: "";
      display: block;
      width: 6px;
      height: 2px;
      background-color: #509aff;
      border-radius: 50%;
      position: absolute;
      top: 0px;
      left: -2.5px;
    }
  }
  .time-content-line {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    cursor: grab;
    transform: translateZ(0);
    &:active {
      cursor: grabbing;
    }
    .outer-round {
      position: absolute;
      &::after {
        content: "";
        display: block;
        width: 16px;
        height: 16px;
        border: 2px solid #ccc;
        border-radius: 50%;
      }
    }
    .drag-svg {
      // position: absolute;
    }
  }

  .time-content-main {
    width: 100%;
    min-height: 100%;
    .time-main {
      width: 100%;
      height: 100%;
      display: flex;
      position: relative;
      .complateSecend {
        background-color: #f0f1f6 !important;
        border: 1px solid rgba(166, 166, 182, 0.61) !important;
      }
      .close-box {
        position: absolute;
        z-index: 3;
        height: 50px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        overflow: hidden;
        .close-box-in {
          height: 28px;
          padding: 0 30px;
          // background: linear-gradient(270deg, #6b97cf 0%, #456fb3 100%);
          border-radius: 2px;
          // color: #fff;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          span:first-child {
            box-sizing: border-box;
            display: block;
            @include ellipsis();
          }
        }
      }
      .task-box-obj {
        position: absolute;
        // transform: translate(0, -50%);
        z-index: 3;
        // padding: 0 30px;
        // height: 50px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        &:hover {
          .task-box-obj-out {
            display: block;
          }
          .round {
            display: block;
          }
        }
        .task-box-obj-out {
          position: absolute;
          left: -24px;
          top: -4px;
          right: -24px;
          bottom: -4px;
          background-color: #fff;
          border-radius: 4px;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
          display: none;
          z-index: 1;
        }
        .round-change {
          left: -6px;
          right: -6px;
        }
        .task-box-obj-in {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          position: relative;
          &:hover {
            cursor: auto;
          }
          &:active {
            cursor: grabbing;
          }
        }
        .round {
          position: absolute;
          width: 16px;
          height: 16px;
          display: none;
          background-color: #6e798a;
          border-radius: 50%;
          border: 3px solid #fff;
          box-sizing: border-box;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
          &:hover {
            background-color: $color-active !important;
          }
          svg {
            transform-origin: 0 0;
            position: absolute;
            top: 5px;
            left: 5px;
            pointer-events: none;
          }
          .full-screen {
            z-index: 3;
            position: absolute;
            display: flex;
            align-items: center;
            height: 16px;
            transform-origin: 0px 50%;
            left: 4px;
            top: -3px;
            .jt {
              float: left;
              width: 0;
              height: 0;
              border-width: 8px;
              border-style: solid;
              border-color: transparent transparent transparent $color-active;
              border-radius: 5px;
            }
            .line {
              width: 0;
              flex: 1;
              height: 2px;
              background-color: $color-active;
            }
          }
          .hot-zone {
            position: absolute;
            left: -10px;
            top: -10px;
            right: -10px;
            bottom: -10px;
            z-index: 1;
          }
        }
        .round-display {
          display: block !important;
        }
        .round-left {
          left: -45px;
        }
        .round-right {
          right: -45px;
        }
        .not-drag-left {
          left: -24px;
        }
        .not-drag-right {
          right: -24px;
        }
        .round-hidden {
          display: none !important;
        }
      }
      .iocn_resize {
        font-size: 12px;
        transform: scale(0.7);
        color: #c3c6cb;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        &:hover {
          cursor: w-resize;
        }
      }
      .iocn_resize_left {
        left: 4px;
      }
      .iocn_resize_right {
        right: 4px;
      }
      .time-tr {
        flex-shrink: 0;
        position: relative;
        z-index: 1;
      }
      .time-tr-svg {
        position: absolute;
      }
      .task-box {
        width: 0;
        flex: 1;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 5;
        justify-content: flex-start;
        box-sizing: border-box;
      }
      .task-info {
        padding: 0 6px;
        font-size: 12px;
        height: 100%;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
        text-align: center;
      }
      .time-tr--item {
        display: flex;
        flex-direction: column;
        .time-tr {
          flex-shrink: 0;
          position: relative;
          z-index: 1;
        }
      }
      .time-main--item {
        height: 100%;
        min-height: 100%;
        flex-shrink: 0;
        position: relative;
      }
      // .time-main--item:nth-child(2n-1) {
      //   background: rgb(248, 249, 251);
      // }
      // .time-main--item:nth-child(2n) {
      //   background: rgb(243, 244, 247);
      // }
    }
  }
  .tool-week {
    position: absolute;
    top: 96px;
    right: 62px;
    z-index: 999;
    display: flex;
    align-items: center;
    .el-dropdown-link {
      height: auto;
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
      box-sizing: border-box;

    }
    .tool-week-day {
      margin-right: 10px;
    }
    .arrow-down {
      transform: rotate(90deg);
      color: rgba(32, 32, 32, 0.24);
    }
    .tool-week-day,
    .tool-week-select {
      cursor: pointer;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      font-size: 14px !important;
      color: initial;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      padding: 0 16px;
      box-sizing: border-box;
      .el-dropdown-link {
        font-size: 14px !important;
      }
      &:hover {
        color: $color-active;
        i {
          color: $color-active;
        }
      }
    }
    .rotaEle {
      transform: rotate(-90deg);
    }
  }
  .hover-item {
    background-color: rgba(166, 166, 182, 0.16) !important;
  }
  .time-line-connect {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    min-height: 100%;
    .path-jt {
      &:hover .time-path-jt {
        fill: rgba(32, 32, 32, 0.6);
      }
    }
    .time-path-jt {
      fill: rgba(32, 32, 32, 0.6);
    }
    .time-path-copy {
      stroke: rgba(32, 32, 32, 0.6);
      position: relative;
      z-index: 2;
      padding: 20px;
      stroke-linejoin: round;
      cursor: pointer;
    }
    .time-path {
      stroke: #b7bdc5;
      position: relative;
      z-index: 2;
      padding: 20px;
      stroke-linejoin: round;
      &:hover {
        stroke: rgba(32, 32, 32, 0.6);
        cursor: pointer;
      }
    }
  }
  .time-line-svg {
    display: flex;
  }
  ::-webkit-scrollbar {
    height: 0;
  }
}
</style>
